import { MaritalStatus } from './marital-status.interface';
import { MaritalStatusService } from './marital-status.service';
const service = new MaritalStatusService();

export interface MaritalStatusState {
   maritalStatuses: Array<MaritalStatus>;
}

const state: MaritalStatusState = {
   maritalStatuses: [],
};

const getters = {
   maritalStatuses(state: MaritalStatusState) {
      return state.maritalStatuses;
   },
};

const mutations = {
   SET_MARITAL_STATUSES(state: MaritalStatusState, maritalStatuses: Array<MaritalStatus>) {
      state.maritalStatuses = maritalStatuses;
   },
};

const actions = {
   async getMaritalStatuses(context: any) {
      return await service.getMaritalStatuses().then((response) => {
         context.commit('SET_MARITAL_STATUSES', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
